export default __webpack_public_path__ + "static/media/person.4e5237d1.svg";